import {ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {JwtService} from '../services/jwt.service';
import {Injectable} from '@angular/core';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {
  constructor(private jwt: JwtService) {
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return !this.jwt.isTokenExpired();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return !this.jwt.isTokenExpired();
  }
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/guards/auth.guard.ts